// UN VÍDEO INCRUSTADO, reconociendo de dónde viene.
//
// Estaba dentro del widget de ayuda, que era su único consumidor. Al publicar vídeos también en el
// portal del paciente, copiarlo habría dejado dos expresiones regulares que reconocen enlaces de
// YouTube: la primera vez que alguien pegue un formato nuevo (un `youtube.com/shorts/…`, pongamos)
// se arreglaría en una y en la otra no, y nadie sabría por qué el mismo vídeo funciona en un sitio
// y en el otro no.
//
// Lo que hace, en orden: si reconoce YouTube o Vimeo, lo incrusta; si es un .mp4, lo reproduce con
// el reproductor del navegador; y si no reconoce nada pero el enlace es http(s), deja un enlace para
// abrirlo fuera. Un enlace que no sea http(s) NO se pinta — un `javascript:` en un href dentro del
// portal del paciente es un agujero, y aquí lo escribe alguien de confianza pero el saneado no
// cuesta nada.
// t459 · EN LA EDICIÓN LOCAL (Biango en la clínica, sin internet) no se incrusta nada de fuera: un vídeo de YouTube o de Vimeo
// pediría a internet en cuanto se abre el artículo. Se dice que no está en esta edición (utils/edicionLocalEstado: en la nube, no).
import { esEdicionLocal } from '../utils/edicionLocalEstado'
import { t } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function VideoEmbed({ url, radio = 10, style = {}, onEnlace = null }) {
  const u = String(url || '');
  if (u && esEdicionLocal()) {
    return <div style={{ padding: '10px 12px', borderRadius: radio, border: '1px dashed var(--border)', fontSize: '13px', color: 'var(--text-secondary)', ...style, aspectRatio: 'auto' }}>
      {t('components.VideoEmbed.los_videos_no_estan_en', 'Los vídeos no están en la edición local de Biango (necesitan internet).')}
    </div>;
  }
  const yt = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/);
  const vimeo = u.match(/vimeo\.com\/(\d+)/);
  const src = yt ? `https://www.youtube.com/embed/${yt[1]}` : vimeo ? `https://player.vimeo.com/video/${vimeo[1]}` : null;
  const seguro = /^https?:\/\//i.test(u) ? u : null;
  const caja = { width: '100%', aspectRatio: '16/9', borderRadius: radio, border: 'none', background: '#000', display: 'block', ...style };

  if (src) {
    return (
      <iframe src={src} style={caja} title={t('components.VideoEmbed.video', 'vídeo')} loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen />
    );
  }
  if (seguro && /\.mp4($|\?)/i.test(seguro)) return <video src={seguro} controls playsInline style={caja} />;
  if (!seguro) return null;
  // `noreferrer noopener`: sin esto, la página que se abre puede manipular la que la abrió.
  return onEnlace
    ? onEnlace(seguro)
    : <a href={seguro} target="_blank" rel="noreferrer noopener">{t('components.VideoEmbed.ver_video', 'Ver vídeo')}</a>;
}
